import "./SaasToolsSaasGenix.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import SaasToolsFeatures from "./sections/SaasToolsFeatures";
import WhyChoose from "./sections/WhyChoose";
import Reviews from "./sections/Reviews";
import Blog from "./sections/Blog";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function SaasToolsSaasGenixPage() {
  return <div>
      <Header />
      <Hero />
      <SaasToolsFeatures />
      <WhyChoose />
      <Reviews />
      <Blog />
      <Contact />
      <Footer />
    </div>;
}